var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.classes,
    attrs: {
      "aria-label": _vm.accessibilityLabel
    }
  }, [(_vm.source == 'placeholder' || !_vm.finalSource) ? _c('div', {
    staticClass: "Polaris-Icon__Placeholder"
  }) : _vm._e(), _vm._v(" "), (_vm.source != 'placeholder' && _vm.finalSource) ? _c('svg', {
    staticClass: "Polaris-Icon__Svg",
    attrs: {
      "viewBox": _vm.finalSource.viewBox
    },
    domProps: {
      "innerHTML": _vm._s(_vm.finalSource.body)
    }
  }) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40b5b950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40b5b950","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisIcon.vue
// module id = 99
// module chunks = 0